import { canNavigate } from "app/common/services/canNavigate";
import type { INavItem } from "./SideNav.types";

export const isBeta = (navListItem: INavItem) => {
    return navListItem.isBeta;
};

export const isNew = (navListItem: INavItem) => {
    return navListItem.isNew;
};

export const isLocked = (navListItem: INavItem) => {
    const isNavigationAllowed = canNavigate({ name: navListItem.state }, { ...navListItem });
    return !isNavigationAllowed || navListItem.lockIcon;
};
